import { Calculator, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

export function GSTPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-6 p-4">
      <div className="flex items-center justify-between">
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-900">
          <Calculator className="h-8 w-8 text-blue-600" />
          GST reconciliation
        </h1>
        <Link to="/dashboard" className="text-sm font-medium text-blue-600 hover:underline">
          ← Dashboard
        </Link>
      </div>
      <p className="text-slate-600">
        Match Purchase Register with GSTR-2B. Summary counts appear on the main dashboard under{' '}
        <strong>GST reconciliation</strong>.
      </p>
      <div className="rounded-xl border border-slate-200 bg-slate-50 p-6">
        <p className="text-sm text-slate-700">
          Use <code className="rounded bg-white px-1">POST /api/gst-reconcile</code> with OpenAI configured,
          or view seeded statuses via <code className="rounded bg-white px-1">GET /api/dashboard/gst-summary</code>.
        </p>
        <Link
          to="/dashboard"
          className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-blue-600 hover:underline"
        >
          <ExternalLink className="h-4 w-4" />
          Open dashboard GST widget
        </Link>
      </div>
    </div>
  );
}
